export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_2104fa3b-a1fa-4231-ad42-d29bdcbd797a/artifacts/3j7swhcj_STGLogo_Black.png";

export const HEADSHOT_URL =
  "https://customer-assets.emergentagent.com/job_89256e90-ed4c-40f9-8edc-e5e5eb712f2a/artifacts/vki05wh8_IMG_7974.png";

export const CONTACT = {
  email: "Jeremy@summittransformationgroup.com",
  phone: "(814) 571-3565",
  location: "State College, PA",
  linkedin: "https://www.linkedin.com/in/jeremy-bean-70802819",
};

export const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};
